import { MarkdownItem } from "@general-ui/typography-item/typography-item";
import images from "images";
import { SuperAdminNotification } from "types/working-model";

interface Props {
	notification: SuperAdminNotification;
}
export default function SuperAdminNoticationRow({
	notification
}: Props) {
	return (
		<div className="notification-item">
			<img src={images.TellyPresenting} />
			<div className="notification-item-content">
				<MarkdownItem>{notification?.config?.content}</MarkdownItem>
			</div>
		</div>
	);
}